import { render, staticRenderFns } from "./QuestionList.vue?vue&type=template&id=b52e565e&scoped=true&"
import script from "./QuestionList.vue?vue&type=script&lang=js&"
export * from "./QuestionList.vue?vue&type=script&lang=js&"
import style0 from "./QuestionList.vue?vue&type=style&index=0&id=b52e565e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b52e565e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b52e565e')) {
      api.createRecord('b52e565e', component.options)
    } else {
      api.reload('b52e565e', component.options)
    }
    module.hot.accept("./QuestionList.vue?vue&type=template&id=b52e565e&scoped=true&", function () {
      api.rerender('b52e565e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/game/space/components/QuestionList.vue"
export default component.exports